import Pencil from '@/components/Icons/Pencil';
import { FieldProps } from 'formik';
import s from '@/components/Forms/TextBox.module.css';

type TextInputProps = {
  labelCopy: string;
  showIcon?: boolean;
  placeholder: string;
  type?: string;
};

export default function TextInput({
  showIcon = false,
  type = 'text',
  labelCopy,
  field, // { name, value, onChange, onBlur }
  form: { touched, errors }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
  ...props
}: FieldProps & TextInputProps) {
  const displayError = errors[field.name] && touched[field.name];
  const placeholderOpt = props.placeholder === ' ' ? '' : s.with_placeholder;
  const labelHidden = !labelCopy || !labelCopy.length;
  return (
    <div className={`${s.field} ${displayError ? s.error : ''}`}>
      <input
        className={`${s.input} ${labelHidden ? s.no_label : ''}`}
        type={type}
        {...field}
        {...props}
      />
      <label className={`${s.label} ${placeholderOpt}`} htmlFor={field.name}>
        {labelCopy}
      </label>
      {displayError ? (
        <div className={s.error_copy}>{errors[field.name] as string}</div>
      ) : null}
      {showIcon && (
        <Pencil
          currentColor="text-black-300"
          addClassStyles={s.eye_toggle_icon_focused}
        />
      )}
    </div>
  );
}

export function TransparentTextInput({
  field, // { name, value, onChange, onBlur }
  form: { touched, errors }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
  ...props
}: FieldProps & TextInputProps) {
  const displayError = errors[field.name] && touched[field.name];

  return (
    <div className={`relative ${displayError ? s.error : ''}`}>
      <input
        className={`copy-l outline-none w-[26.2rem] text-center`}
        {...field}
        {...props}
      />
      {displayError ? (
        <div className={`absolute text-red-error -bottom-7 left-7 normal-case`}>
          {errors[field.name] as string}
        </div>
      ) : null}
    </div>
  );
}
